import React, { useState, useEffect } from "react";
import "./PromoPopup.css";
import promoImg from "../assets/doctor2.png"; // стави си слика тука
import { FaTimes } from "react-icons/fa";

const PromoPopup = () => {
    const [show, setShow] = useState(false);

    useEffect(() => {
        setShow(true);
    }, []);

    if (!show) return null;

    return (
        <div className="popup-overlay">
            <div className="popup-content">

                <button className="close-btn" onClick={() => setShow(false)}>
                    <FaTimes />
                </button>

                <div className="popup-left">
                    <img src={promoImg} alt="Доктор" />
                </div>

                <div className="popup-right">
                    <h2>АКЦИЈА</h2>

                    <p className="popup-title">Лекарски уверенија

                        <span className="popup-subtitle">
    (не важи за возачка дозвола)
  </span>
                    </p>

                    <div className="price-box">
                        <span className="old-price">1600 ден</span>
                        <span className="new-price">800 ден</span>
                    </div>

                    <p className="popup-desc">
                        Искористете ја нашата ограничена понуда за брзи и квалитетни услуги.
                        <br/>
                         Акциската цена важи за лекарски уверенија за работа,
  училиште, факултет и други намени.

                    </p>


                    <button
                        className="popup-btn"
                        onClick={() => {
                            setShow(false); // 👈 затвори popup
                            document.getElementById("appointment").scrollIntoView({
                                behavior: "smooth"
                            });
                        }}
                    >
                        Закажи термин
                    </button>


                </div>

            </div>
        </div>
    );
};

export default PromoPopup;